module.exports = __webpack_public_path__ + "img/log.eb176327.svg";